import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarouselTemplate from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const logos = [
  carouselLogos.PEPSICO,
  carouselLogos.INSTACART,
  carouselLogos.NEXTDOOR,
  carouselLogos.BOX,
  carouselLogos.GENERALMILLS,
  carouselLogos.DSW,
  carouselLogos.THENEWYORKTIMES,
  carouselLogos.CVS_HEALTH,
  carouselLogos.TELUSDIGITAL,
  carouselLogos.ANTHROPOLOGIE,
]

const copy = {
  description: `Tune in to hear from our partners and leaders across every industry`,
}

const LogoCarousel = () => (
  <StyledSection variant="noCopy">
    <Section.Contents>
      <StyledLogoCarouselTemplate logos={logos} heading={copy.description} />
    </Section.Contents>
  </StyledSection>
)

const StyledLogoCarouselTemplate = styled(LogoCarouselTemplate)`
  max-width: 550px;
`

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      padding: 64px 40px;
    }

    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding: 64px 80px;
    }
  }
`

export default LogoCarousel
